import BrancheSelect from '@/generated/controls/branche/BrancheSelect.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: BrancheSelect
})
